var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.024,
    height: 79.25,
    viewBox: "886.506 1776 15.506 19.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m901.73 1779.949-7.302-3.881c-.16-.1-.36-.08-.54 0l-7.082 3.88c-.18.1-.3.28-.3.5v5.082c0 4.261 2.52 8.102 6.422 9.822l.98.42c.08.04.14.04.22.04.08 0 .16-.02.22-.04l1.1-.48a10.687 10.687 0 0 0 6.562-9.862v-4.981c.02-.2-.1-.4-.28-.5Zm-.82.84v4.641c0 3.861-2.301 7.322-5.862 8.822l-.9.38-.76-.32a9.599 9.599 0 0 1-5.742-8.782v-4.741l6.522-3.581 6.741 3.58Zm-10.123 5.101a.628.628 0 0 1-.14-.42.55.55 0 0 1 .2-.38c.24-.2.6-.18.8.06l1.56 1.82 4.042-3.26c.12-.1.26-.14.42-.12.14.02.28.08.38.2.1.12.14.26.12.42-.02.14-.08.28-.2.38l-4.481 3.62c-.1.08-.22.12-.36.12-.16 0-.32-.06-.42-.2l-1.921-2.24Z",
    fill: "#ffeb00",
    fillRule: "evenodd",
    "data-name": "noun-security-3908072"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.193307fcb370c7d1953718a66347b0bd.svg";
export { ForwardRef as ReactComponent };